import React, { useState } from "react";
import { supabase } from "../utils/supabaseClient";
import "../styles/reset-password.css";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const updatePassword = async () => {
    if (password !== confirm) {
      alert("Passwords do not match");
      return;
    }

    const { error } = await supabase.auth.updateUser({ password });
    if (error) alert(error.message);
    else alert("Password updated successfully");
  };

  return (
    <div className="reset-page">
      <div className="reset-card">
        <h2>Reset Password</h2>
        <input
          type="password"
          placeholder="New password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder="Confirm password"
          onChange={(e) => setConfirm(e.target.value)}
        />
        <button onClick={updatePassword}>Update Password</button>
      </div>
    </div>
  );
};

export default ResetPassword;
